// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__1wk5j","noInteraction":"EventWrapper_noInteraction__1LGBc"};